export default [{
  path: '/',
  name: 'root',
  meta: { requiresAuth: false },
  component: () => import('@/layouts/AuthTemplate'),
  children: [
    { path: '/', component: () => import('@/views/Auth/SignIn') }
  ]
}]
